import { Sizes } from '../types';

class WithSizes {
  sizes: Sizes;

  constructor(sizes: Sizes) {
    this.sizes = sizes;
  }

  onResize(sizes: Sizes) {
    this.sizes = sizes;
  }
}

export default WithSizes;
